<template>
  <pl-dialog
    title="Configure Two Factor Authentication"
    size="md"
    @close="$emit('close')"
    :disableOutsideClick="true"
  >
    <div v-if="is_loading === false" class="h-full relative">
      <div v-if="is_enable === false" class="h-full">
        <div class="h-full flex flex-col">
          <div class="flex-grow h-full px-8 py-5">
            <ul class="flex flex-col space-y-4 flex-grow h-full">
              <li class="flex flex-col space-y-2">
                <div class="flex items-start justify-between">
                  <div class="flex flex-col space-y-2">
                    <div class="mb-4">
                      1. You will need an authenticator mobile app to complete
                      this process:
                    </div>
                    <div class="ml-5 flex flex-col space-y-2">
                      <span class="underline text-blue-500 cursor-default"
                        >Google Authenticator</span
                      >
                      <span class="underline text-blue-500 cursor-default"
                        >Microsoft Authenticator</span
                      >
                      <span class="underline text-blue-500 cursor-default"
                        >Duo Mobile</span
                      >
                    </div>
                  </div>
                  <div v-if="qrcode" class="w-44 h-44">
                    <img :src="qrcode" />
                  </div>
                </div>
              </li>
              <li class="flex flex-col space-y-2 mb-6">
                <div>2. Scan the QRCode with your authenticator</div>
                <div class="ml-5 flex flex-col space-y-2">
                  <span class="text-blueGray-600 font-light"
                    >If you can't scan the QRCode use this code:</span
                  >
                  <input
                    :disabled="true"
                    v-model="secret"
                    class="px-3 py-2 rounded border border-solid border-gray-200"
                  />
                </div>
              </li>
              <li class="flex flex-col space-y-2 mt-10">
                <div>
                  3. After scanning the QRCode, enter the code
                  generated by authenticator mobile app
                </div>
                <div class="ml-5 flex flex-col space-y-2">
                  <input
                    v-model="token"
                    placeholder="Enter six code generated..."
                    class="px-3 py-2 rounded border border-solid border-gray-200"
                  />
                </div>
              </li>
            </ul>
          </div>
          <div class="px-8 py-5">
            <div class="flex items-center justify-end space-x-3">
              <button
                @click="$emit('close')"
                class="bg-gray-50 hover:bg-gray-100 border text-blueGray-800 border-solid border-gray-200 px-3 py-2 rounded"
              >
                Cancel
              </button>
              <button
                @click="handleVerify2FA()"
                class="bg-primary flex items-center space-x-2 px-3 py-2 border border-solid border-primary rounded text-white"
              >
                <span>Verify Now</span>
                <div class="loader" v-show="is_verify"></div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="h-full">
        <div class="flex flex-col h-full">
          <div class="flex-grow h-full px-8 py-6">
            <div class="flex flex-col space-y-3">
              <div class="w-8/12 text-gray-800">
                To remove
                <span class="font-semibold"
                  >Two Factor Authentication (2FA)</span
                >, enter the six digit code, generated by authenticator mobile
                app
              </div>
              <div class="flex flex-col space-y-2">
                <input
                  v-model="formattedInput"
                  maxlength="7"
                  placeholder="Enter six code generated..."
                  class="px-3 py-2 focus:border-red-500 rounded border border-solid border-gray-200"
                />
              </div>
            </div>
          </div>
          <div class="py-5 px-8">
            <div class="flex justify-end items-end">
              <button
                class="bg-red-500 hover:bg-red-600 text-white px-3 py-2 rounded"
                @click="handleRemove()"
              >
                Remove Two Factor Authentication
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="h-full flex justify-center items-center">
      <pl-spinner style="width: 40px; height: 40px"></pl-spinner>
    </div>
  </pl-dialog>
</template>
<script>
  import Vue from 'vue';
  import { mapGetters } from 'vuex';
  import { EventBus } from "utils/event-bus";
  import axios from 'axios';
  export default Vue.extend({
    data() {
      return {
        secret: null,
        qrcode: null,
        is_loading: false,
        token: null,
        is_verify: false,
        token_remove: '',
        is_enable: null,
      };
    },
    computed: {
      ...mapGetters(['getProfile']),
      formattedInput: {
        get() {
          let digits = this.token_remove.replace(/\D/g, '');
          let formatted = digits.replace(/(\d{3})(\d{3})/, '$1 $2');
          return formatted;
        },
        set(value) {
          this.token_remove = value.replace(/\D/g, '');
        },
      },
    },
    props: {
      type2FA: {
        type: String,
      },
    },
    methods: {
      handleVerify2FA: async function () {
        try {
          this.is_verify = true;
          await axios.post(`/api/users/two-factor-authentication/verify`, {
            secret: this.secret,
            token: this.token,
            user_id: this.getProfile.id,
          });
          this.is_verify = false;
          const toast = {
            type: 'Success',
            message: 'Two Factor Authentication is Enabled!',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } catch (error) {
          const toast = {
            type: 'Error',
            message: 'The six code digit is not valid! Please try again!',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
          this.is_verify = false;
        }
      },
      handleRemove: async function () {
        try {
          const data = await axios.post(`/api/users/two-factor-authentication/remove`, {
            token: this.formattedInput,
            user_id: this.getProfile.id,
          });
          if(data) {
            this.is_enable = false;
            this.$emit('close');
            const toast = {
              type: 'Success',
              message: 'Two Factor Authentication is Disabled!',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          }
        } catch (error) {
          const toast = {
            type: 'Error',
            message: 'The six code digit is not valid! Please try again!',
            time: 5000,
          };
          EventBus.$emit('createToast', toast);
        }
      },
    },
    mounted: async function () {
      this.is_loading = true;
      const response = await axios.get(`/api/users/two-factor-authentication/${this.getProfile.id}`);
      if (response.data.secret) {
        const decryptedData = await axios.post(`/api/users/two-factor-authentication/decrypt`, {
          secret: response.data.secret,
          userId: this.getProfile.id
        });

        this.secret = decryptedData.data.secret;
        this.qrcode = decryptedData.data.qrCode;

        this.is_enable = this.getProfile.two_factor_authentication_method !== null ? true : false;
        this.is_loading = false;
      }
    },
  });
</script>



// WEBPACK FOOTER //
// Enable2FAModal.vue?489346d9